export default (state = '', action) => {
    let { type, payload } = action
    switch (type) {
        case 'LANDTRUST_RIGHT_MENU_EXPAND':
            return true
        case 'LANDTRUST_RIGHT_MENU_HIDE':
            return false
        case 'LOGOUT':
            return null
        default:
            return state
    }
}